import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";
import { editEventError } from "@planzone/dto";

function createInteractor(repository: Repository): Interactor {
  return ({ event, nextEvent }) =>
    present(
      repository
        .editEvent(event, nextEvent)
        .then(({ uuid }) => repository.getEvent(uuid))
        .catch((e) =>
          Promise.reject({
            error: { ...editEventError, ...e },
            event,
            nextEvent,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
